var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        dragover: function($event) {
          $event.preventDefault()
        },
        drop: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "image-previews", on: { drop: _vm.dragFile } },
        [
          _vm._l(_vm.imagesData, function(item, index) {
            return _c("div", { key: item.index, staticClass: "preview-item" }, [
              _c(
                "div",
                {
                  staticClass: "preview-item-inner",
                  class: {
                    error: item.error || !_vm.namesChecker[index].length
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "image-remove",
                      on: {
                        click: function($event) {
                          return _vm.imageRemove(index)
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "31",
                            height: "31",
                            viewBox: "0 0 31 31",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("rect", {
                            attrs: {
                              width: "31",
                              height: "31",
                              rx: "15.5",
                              fill: "url(#paint0_linear_6869_23016)"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M12.001 12L18.9997 18.9988",
                              stroke: "white",
                              "stroke-width": "3",
                              "stroke-linecap": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M18.999 12L12.0003 18.9988",
                              stroke: "white",
                              "stroke-width": "3",
                              "stroke-linecap": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "defs",
                            [
                              _c(
                                "linearGradient",
                                {
                                  attrs: {
                                    id: "paint0_linear_6869_23016",
                                    x1: "46.5",
                                    y1: "15.5",
                                    x2: "15.5",
                                    y2: "-15.5",
                                    gradientUnits: "userSpaceOnUse"
                                  }
                                },
                                [
                                  _c("stop", {
                                    attrs: { "stop-color": "#1F32C7" }
                                  }),
                                  _vm._v(" "),
                                  _c("stop", {
                                    attrs: {
                                      offset: "1",
                                      "stop-color": "#3CD1F3"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  item.type.match("video")
                    ? _c(
                        "div",
                        {
                          staticClass: "video-wrapper",
                          on: {
                            mouseenter: _vm.autoplayOn,
                            mouseleave: _vm.autoplayOff
                          }
                        },
                        [
                          _c("LazyVideo", {
                            staticClass: "preview-image video",
                            attrs: {
                              src: item.src,
                              attrs: {
                                controls: false,
                                loop: true,
                                muted: true
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _c("img", {
                        staticClass: "preview-image",
                        attrs: {
                          src: item.src,
                          width: "292",
                          height: "216",
                          loading: "lazy"
                        }
                      }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.namesChecker[index],
                        expression: "namesChecker[index]"
                      }
                    ],
                    staticClass: "image-name",
                    attrs: { type: "text" },
                    domProps: { value: _vm.namesChecker[index] },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.namesChecker, index, $event.target.value)
                        },
                        function($event) {
                          return _vm.editName($event, index, item)
                        }
                      ],
                      click: _vm.selectValue
                    }
                  })
                ]
              ),
              _vm._v(" "),
              item.error
                ? _c("p", { staticClass: "error-text" }, [
                    _vm._v("\n        " + _vm._s(item.error) + "\n      ")
                  ])
                : !_vm.namesChecker[index].length
                ? _c("p", { staticClass: "error-text" }, [
                    _vm._v("\n        Enter image name\n      ")
                  ])
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "previews-bottom" },
            [
              _c("p", { staticClass: "note" }, [
                _vm._v(
                  "\n        Min res. 200x200px | Max file size 50MB | Max 30 sec. long | File\n        formats PNG, GIF, JPEG, SVG, MP4\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-button",
                { attrs: { secondary: "" }, on: { click: _vm.focusInput } },
                [_vm._v("Add More Files")]
              ),
              _vm._v(" "),
              _c(
                "v-button",
                {
                  attrs: { disabled: _vm.dataIsNotValid },
                  on: { click: _vm.saveFiles }
                },
                [_vm._v("Next")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            ref: "uploadFile",
            attrs: {
              id: "uploadFile",
              type: "file",
              accept:
                "image/gif, image/png, image/jpeg, image/svg+xml, video/mp4",
              multiple: ""
            },
            on: { change: _vm.uploadFile }
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }